import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import './styles.less';

const FileField = ({ input, meta: { touched, error } }) => {
	const inputRef = useRef();

	const handleFileChange = e => {
		const file = e.target.files[0];
		input.onChange(file);
	};

	const handleRemoveFile = () => {
		input.onChange(null);
		if (inputRef.current) {
			inputRef.current.value = '';
		}
	};

	return (
		<div className="file-field__column">
			<div className="file-field__wrapper">
				<div className="file-field__upload-button" onClick={() => inputRef.current?.click()} />

				{input.value && typeof input.value === 'object' && (
					<span className="file-field__file-label">
						<span className="file-field__file-name">{input.value.name}</span>
						<div className="file-field__close-button" onClick={handleRemoveFile} />
					</span>
				)}

				<input
					ref={inputRef}
					id={input.name}
					type="file"
					accept=".xlsx"
					style={{ display: 'none' }}
					onChange={handleFileChange}
				/>
			</div>

			{touched && error && <span className="validation_error">{error}</span>}
		</div>
	);
};

FileField.propTypes = {
	input: PropTypes.shape({
		name: PropTypes.string.isRequired,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		onChange: PropTypes.func.isRequired,
	}).isRequired,
	meta: PropTypes.shape({
		touched: PropTypes.bool,
		error: PropTypes.string,
	}).isRequired,
};

export default FileField;
